import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

import Alert from '../../Atoms/Alert'

class WarningAlert extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      showModal: !!props.warningMessage
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.warningMessage === null && this.props.warningMessage !== null) {
      this.setState({ showModal: true })
    }

    if (prevProps.warningMessage !== null && this.props.warningMessage === null) {
      this.setState({ showModal: false })
    }
  }

  handleBackdropPress = () => {
    this.setState({ showModal: false })
  }

  render () {
    const isVisible = !!(this.state.showModal && this.props.warningMessage)
    return (
      <Alert visible={isVisible} onConfirm={this.handleBackdropPress}>
        {this.props.warningMessage && (
          <>
            <Text bold>{this.props.warningMessage.title}</Text>
            <Text overrides={{
              marginTop: theme.gutterUnit
            }}
            >
              {this.props.warningMessage.message}
            </Text>
          </>
        )}
      </Alert>
    )
  }
}

const mapStateToProps = (state) => ({
  warningMessage: state.game.warningMessage
})

export default connect(mapStateToProps, {})(WarningAlert)
